export const STATE_PROP = 'claimingProcess';
export const fieldKey = {
  materialNumber: 'materialNumber',
  serialNumber: 'serialNumber',
  claimingCode: 'claimingCode'
};
